import { createStyle } from 'cadenza/map/style/create-style';
import { resolveReferenceToIndex } from 'cadenza/utils/json';

export class FeatureStyleResolver {

  #styles;
  #styleCache;

  /**
   * Style resolver: creates OpenLayer styles and caches them.
   *
   * @param {object[]} styles - Raw feature styles.
   */
  constructor (styles = []) {
    this.#styles = styles;
    this.#styleCache = Array.from({ length: styles.length }, Object);
  }

  /**
   * Provides a style according to given style reference and the geometryTyp.
   *
   * @param {string} style - A JSON Reference to the style.
   * @param {GeometryType} geometryType - A feature geometry type.
   * @return {Style|Style[]|Function} An OpenLayers style.
   */
  resolve (style, geometryType) {
    const styleIndex = resolveReferenceToIndex(style.$ref);
    const cacheCell = this.#styleCache[styleIndex];
    // If yet not cached, create and cache new OpenLayers style.
    if (!cacheCell[geometryType]) {
      cacheCell[geometryType] = createStyle(this.#styles[styleIndex], { geometryType });
    }
    return cacheCell[geometryType];
  }

}
